/**
 * HTTP layer for a customer's sectioned settings document. The odl_app
 * customer-settings read/write surface.
 *
 * Contains:
 * - fetchCustomerSettings: read a customer's settings sections
 * - patchCustomerSettings: write a customer's settings sections
 */
import apiClient from '@sophocles/http-common';

// Consolidated customer-settings endpoint.  Companion to the
// site-settings / site-group-settings endpoints (see
// `pliny.odl_app.views.customer_settings` for the backend).
// Replaces the scattered surface of the legacy CustomerSettings tabs
// (Customer, CustomerOptions, CustomerSpecialInstructions, …) with a
// single sectioned payload — V2 settings reads / writes through it.
const path = customerId => `odl-app/customer-settings/${customerId}/`;

export const fetchCustomerSettings = customerId => apiClient.get(path(customerId)).then(res => res.data);

export const patchCustomerSettings = (customerId, payload) =>
  apiClient.patch(path(customerId), payload).then(res => res.data);
